import styled from "styled-components";

export const EquipDataContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const EquipDataTopbar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const EquipDataBox = styled.div`
  display: grid;
  height: calc(100svh - 378px);
  border: 1px solid ${(props) => props.theme.colors.black12};
  border-collapse: collapse;
  grid-template-columns: 280px 1fr 1fr;
`;

export const EquipDescriptionText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 14px;
  color: ${(props) => props.theme.colors.black60};
`;
